import netlifyImageLoader from './imageLoader';

type NetlifyImageLoaderParams = {
  src: string;
  width: number;
  quality?: number;
};

export default function clampedImageLoader(props: NetlifyImageLoaderParams): string {
  return netlifyImageLoader({
    ...props,
    width: Math.min(props.width, 2048),
  });
}
